import React, { ReactNode } from 'react';
import styles from './styles.module.css';

interface RadioOptionsType {
  title?: string;
  active?: boolean;
  item?: any;
  onClick?: (x?: any) => void;
  children?: ReactNode;
  aside?: ReactNode;
  disabled?: boolean;
  error?: string;
  showError?: boolean;
}

export default function RadioOption({
  title,
  active,
  item,
  onClick,
  children,
  aside,
  disabled = false,
  error,
  showError,
}: RadioOptionsType) {
  return (
    <>
      <label
        key={`${title}`}
        className={`${styles.card} ${active ? styles.activeCard : ''} ${disabled && styles.disabled}`}
        onClick={() => {
          if (onClick && !disabled) {
            if (!active) {
              onClick(item);
            } else {
              onClick({ id: '' });
            }
          }
        }}
      >
        <span className={`${styles.radio} ${active ? styles.activeRadio : ''}`}>
          {active && <span className={styles.radioDot} />}
        </span>

        <div className={styles.content}>{children}</div>

        <div className={styles.priceWrapper}>{aside}</div>
      </label>
      {/* {showError && error && <p className={`inputErrorText`}>{error}</p>} */}
    </>
  );
}
